import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { ChatBotProvider } from '@/contexts/ChatBotContext'
import { CookieConsentProvider } from '@/contexts/CookieConsentContext'
import '@/i18n'
import './index.css'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <CookieConsentProvider>
        <ChatBotProvider>
          <App />
        </ChatBotProvider>
      </CookieConsentProvider>
    </BrowserRouter>
  </StrictMode>
)
